import React, { Component, useState } from 'react'
import store from "@/redux/store";
import { connect } from "react-redux";



import {Button, Calendar, CalendarCell, CalendarGrid, DateInput, DatePicker, DateSegment, Dialog, Group, Heading, Label, Popover} from 'react-aria-components';
import {GridList, GridListItem, ComboBox, Input, ListBox, ListBoxItem} from 'react-aria-components';
import {FieldHolder} from "@/components/holders/FieldHolder";
import type {SwitchProps} from 'react-aria-components';
import { SelectBox } from "@/components/holders/SelectBox";

import moment from 'moment'
import DossierHelper from '@/helpers/DossierHelper';
import {ScheduleView} from './view/Schedule';

class Schedule extends Component {
    constructor(props) {
        super(props);
        this.childOptions = [{id:1, label: "Willekeurig"}, {id:2, label: "Opvolgend"}]
        this.initState = "";
        this.state = {error: null, childOption: this.childOptions[0]}
    }    

    cancelScheduler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        const {onCloseEventHandler} = this.props;
        
        if(onCloseEventHandler) {
            onCloseEventHandler(event);
        }
        
     };


    closeScheduler = (event) => {
        const {items, dossierScheduleItems, userScheduleItems} = this.props;
        event.preventDefault();
        event.stopPropagation();
        
        const {onCloseEventHandler} = this.props;
        if(onCloseEventHandler) {
            onCloseEventHandler(event);
        }

        return false;
    }
        render() {
        const {refreshKey, items, dossierScheduleItems, userScheduleItems, selectedTask} = this.props;
        const {error, childOption} = this.state;
        
        this.initState = JSON.parse(JSON.stringify(this.props));
        return (<>
            <div key={"KDM"} className="timelineItemPanel absolute z-[100]  w-full top-0 left-0  bg-white">
                <div className="relative top-0 left-0">
                <ScheduleView key={refreshKey} selectedTask={selectedTask} {...this.props} onCloseEvent={this.closeScheduler} onCancelEvent={this.cancelScheduler} dossierScheduleItems={dossierScheduleItems} userScheduleItems={userScheduleItems} />
                </div>                
            </div>
                </>);
            
    }
}

const mapStateToProps = state => {
    const {CommunicationCycleReducer, ScheduleReducer} = state;
    const {users,selectedUsers, usersSchedules} = CommunicationCycleReducer;
    const {dossierScheduleItems, userScheduleItems, key, selectedTask} = ScheduleReducer;
    
  return {
    users: users,
    selectedUsers: selectedUsers,
    refreshKey: key,
    usersSchedules: usersSchedules,
    dossierScheduleItems: dossierScheduleItems,
    userScheduleItems: userScheduleItems,
    selectedTask: selectedTask
  };
};

export default connect(mapStateToProps)(Schedule);